const styles = theme => ({
  dialogContainer: {
    maxWidth: '450px',
    width: '100%',
    margin: '0 auto',
    boxShadow: 'none'
  },
  dialogTitle: {
    '& h6': {
      fontFamily: 'Titillium-Regular, Helvetica Neue, sans-serif',
      fontSize: '18px',
      color: '#323233',
      display: 'flex',
      justifyContent: 'space-between',
    }
  },
  dialogInputContainer: {
    padding: '0 24px 15px'
  },
  dialogInput: {
    marginBottom: '15px'
  },
  dialogButtonContainer: {
    padding: '0 16px'
  },
  dialogSubmitButton: {
    fontSize: '14px',
    fontFamily: 'Titillium-SemiBold, Helvetica Neue, sans-serif',
    textTransform: 'uppercase',
    marginBottom: '32px',
    height: '40px'
  }
})
export default styles
